import { useParams } from '@tanstack/react-router';

const useVehicleListingId = () => {
  const { listingId } = useParams({ strict: false });

  return { listingId: listingId as string };
};

export default useVehicleListingId;
